module.exports = __webpack_public_path__ + "203f1d2703935d067e8a5103749e2125.svg";